import React, { ReactNode } from 'react';
import { Box, Container, Drawer, DrawerProps, IconButton, Stack, styled, Toolbar, Typography } from '@mui/material';
import { TitleBar } from 'components/Layouts/TitleBar';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

interface StyledDrawerProps extends DrawerProps {
  inverted: boolean,
}

const StyledDrawer = styled(Drawer,
  {
    shouldForwardProp: prop => prop !== 'inverted'
  })<StyledDrawerProps>(({ theme, inverted }) => ({
    '& .MuiDrawer-paper': {
      width: '100%',
      backgroundColor: inverted ? theme.palette.background.paper : theme.palette.background.default,
    },
  }));

type MobileSlideInDrawerProps = {
  isOpen: boolean,
  onClose: () => void,
  onClosed: () => void,
  title: string,
  subTitle?: string,
  closeButtonText: string,
  invertColors: boolean,
  children?: ReactNode | ReactNode[]
}

export const MobileSlideInDrawer: React.FC<MobileSlideInDrawerProps> = (props: MobileSlideInDrawerProps) => {

  return (
    <StyledDrawer open={props.isOpen} SlideProps={{ onExited: props.onClosed }} hideBackdrop anchor='right' inverted={props.invertColors}>
      <Toolbar sx={{ height: { sm: 76 } }} />
      <TitleBar title={props.title} subtitle={props.subTitle} />
      <Box overflow='auto'>
        <Stack direction='row' alignItems='center' sx={{ backgroundColor: props.invertColors ? 'background.default' : 'background.paper' }}>
          <Container maxWidth='xl'>
            <Stack direction='row' alignItems='center' py={2} gap={2}>
              <IconButton color="primary" onClick={props.onClose}>
                <ArrowBackIcon />
              </IconButton>
              <Typography>{props.closeButtonText}</Typography>
            </Stack>
          </Container>
        </Stack>
        <Container maxWidth='xl'>
          <Stack py={4}>
            {props.children}
          </Stack>
        </Container>
      </Box>
    </StyledDrawer>
  );
};

